import './init-global-components'

const ns = typeof window === 'undefined' ? global : window

ns.LandingPage = require('./landing_pages/LandingPage').default
ns.ReactRailsUJS = require('react_ujs')
